import fileDownload from "js-file-download";

import { set403Error, setUser } from "../actions/user";
import { api } from "../config/variables";
import store from "../store/storeInstance";
import { get } from "../utils/barrels/lodash";
import { reloadUser } from "../utils/functions";
import promiseCache from "../utils/promiseCache";

import { axiosInstance } from "./apiInstance";
import urls from "./urls.json";

export const getZohoInvoices = (pageNo, client) => (dispatch) =>
	axiosInstance
		.get(urls.getZohoInvoices, {
			params: {
				page: pageNo || undefined,
				client_id: client?.id || undefined,
				page_size: 10,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const downloadPOD = (invoice_number) => {
	const reqObj = {
		invoice_number,
		emails: store.getState().billing.add_on_emails.toString(),
	};
	const body = JSON.stringify(reqObj);
	return (dispatch) =>
		axiosInstance
			.post(urls.downloadPOD, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getZohoPayments = (pageNo, client) => (dispatch) =>
	axiosInstance
		.get(urls.getZohoPayments, {
			params: {
				page: pageNo || undefined,
				client_id: client?.id || undefined,
				page_size: 10,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getZohoCreditNotes = (pageNo, client) => (dispatch) =>
	axiosInstance
		.get(urls.getZohoCreditNotes, {
			params: {
				page: pageNo || undefined,
				client_id: client?.id || undefined,
				page_size: 10,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getUnbilledShipments =
	(pageNo, filterVals, page_size) => (dispatch) =>
		axiosInstance
			.get(urls.getUnbilledShipments, {
				params: {
					page: pageNo || undefined,
					page_size: page_size || undefined,
					...filterVals,
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});

export const getZohoDues = (filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getZohoDues, {
			params: {
				...filterVals,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const createOrderId = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.createPayment, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const createRazorPayOrder = (obj, token) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.razorpayOrderCreate, body, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getWalletHistory = (pageNo, page_size, filterVals, query) => {
	const cacheKey = `getWalletHistory_${pageNo}_${page_size}_${query}_${JSON.stringify(
		filterVals
	)}`;
	return (dispatch) => {
		if (promiseCache.isInProgress(cacheKey)) {
			return promiseCache.getExistingPromise(cacheKey);
		}
		const promise = axiosInstance
			.get(urls.getTransactions, {
				params: {
					page: pageNo || undefined,
					page_size: page_size || undefined,
					q: query || undefined,
					...filterVals,
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
		return promiseCache.startCall(cacheKey, promise);
	};
};

export const downloadPassbook = (queryParams) => {
	const emails = store.getState().billing.add_on_emails.toString();
	return (dispatch) =>
		axiosInstance
			.get(urls.downloadPassbook, {
				params: {
					...queryParams,
					emails,
				},
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getInvoiceWorking = (invoice_id, invoice_num) => {
	let admin_api_url = api.server.split("/");
	admin_api_url.pop();
	admin_api_url = admin_api_url.join("/");
	return () =>
		axiosInstance
			.get(
				`${admin_api_url}/api/zoho/download/invoice/?invoice_id=${invoice_id}`,
				{
					responseType: "blob",
				}
			)
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					fileDownload(response.data, `${invoice_num}.xlsx`);
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getShiprocketWalletBalance = () => {
	const cacheKey = `getShiprocketWalletBalance`;
	return (dispatch) => {
		if (promiseCache.isInProgress(cacheKey)) {
			return promiseCache.getExistingPromise(cacheKey);
		}
		const promise = axiosInstance
			.get(urls.getShiprocketBalance)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				const errMsg = get(err, "response.data", false);
				if (
					errMsg?.detail !==
						"Please accept agreement terms to proceed further" &&
					(errResponse === 401 || errResponse === 403)
				) {
					dispatch(
						set403Error({
							error403: true,
							error403Data: errMsg,
						})
					);
					// alert(errMsg, { okButton: ' 戻る ' });
					// window.location.replace(`${api.sso_url}/new-kyc`);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
		return promiseCache.startCall(cacheKey, promise);
	};
};

export const debitAmountFromSR = (obj) => {
	const body = { ...obj, payment_type: "credit" };
	return (dispatch) =>
		axiosInstance
			.post(urls.credit_balance_from_sr_to_rb, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "post",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getGrossMargin =
	(pageNo, filterVals = {}, page_size = 10) =>
	(dispatch) =>
		axiosInstance
			.get(urls.getGrossMargin, {
				params: {
					page: pageNo || undefined,
					page_size: page_size || undefined,
					...filterVals,
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});

export const downloadCreditNotePDF = (creditnoteId) => (dispatch) =>
	axiosInstance
		.get(urls.getCreditNotePDFUrl, {
			params: {
				credit_note_id: creditnoteId,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data.url;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getPaymentGateways = () => (dispatch) =>
	axiosInstance
		.get(urls.getPaymentGateways)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const easebuzzOrderToken = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.easebuzzOrderToken, body)
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const createEasebuzzOrder = (obj, token) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.easebuzzOrderCreate, body, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};
